<template>
  <div class="product-content">
    <h2 class="product-name">{{ briefInfo.name }}</h2>
    <div class="product-meta">
      <div class="meta-item" :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.EnglishName') }}：</span>
          <span class="value">{{ briefInfo.nameOther || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.Alias') }}：</span>
          <span class="value">{{ briefInfo.nameAlias || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.CAS') }}：</span>
          <span class="value">{{ briefInfo.casNo || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.ArtNo') }}：</span>
          <span class="value">{{ briefInfo.sn || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.molecularFormula') }}：</span>
          <span class="value">{{ briefInfo.formulaMolecular || '-' }}</span>
        </div>
      </div>
      <div class="meta-item"  :class="{'meta-item_en':currentLanguage !== 'zh'}">
        <div class="meta-item-box">
          <span class="label"> {{ $t('products.panel.molecularWeight') }}：</span>
          <span class="value">{{ briefInfo.formulaWeight || '-'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'chemistry',
  props: {
    briefInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.product-content {
  width: 100%;
  background: #ffffff;
  padding: 20px;
  
  .product-name {
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin: 0 0 20px;
    text-align: left;
    line-height: 1.4;
  }

  .product-meta {
    margin-bottom: 30px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;

    .meta-item {
      display: flex;
      align-items: flex-start;
      padding: 6px 10px 6px;
      gap: 10px;
      .meta-item-box {
        display: flex;
      }
      &:last-child {
        border-bottom: none;
      }

      .label {
        width: 80px;
        color: #666666;
        font-size: 12px;

        flex-shrink: 0;
      }

      .value {
        flex: 1;
        color: #000000;
        font-size: 12px;
        text-align: left;
        word-break: break-all;
      }
    }
    .meta-item_en {
      display: block !important;
      .label {
        width: auto !important;
        display: block !important;
      }

      .value {
        display: block !important;
      }
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;

    .el-button {
      width: 100%;
      height: 48px;
      border-radius: 8px;

      font-size: 16px;
      border: none;
      transition: all 0.3s ease;

      &:active {
        transform: scale(0.98);
      }
    }
  }
}
</style>